import { format } from 'date-fns';

const DATE_FORMAT = 'yyyy-MM-dd';
const ALL_CATEGORIES = 'All';

/**
 * Build query params for list endpoints (server-side filters).
 * @param {object} pagination — endpoint-specific paging, e.g. { offset: 0, limit: 1000 }
 * @param {Array<{ id: string, name: string }>} categories
 * @param {string[]} committedCategoryNames — e.g. ["All"] or localized names
 * @param {{ from: Date | null, to: Date | null }} committedDateRange
 */
export function buildListParams(
	pagination,
	categories,
	committedCategoryNames,
	committedDateRange,
) {
	const params = { ...pagination };

	const names = (committedCategoryNames || []).filter(
		n => n && n !== ALL_CATEGORIES,
	);
	if (names.length > 0 && Array.isArray(categories)) {
		const ids = [];
		for (const name of names) {
			const cat = categories.find(c => c.name === name);
			if (cat?.id) ids.push(String(cat.id));
		}
		if (ids.length) params.categoryIds = ids;
	}

	if (committedDateRange?.from) {
		params.startDate = format(committedDateRange.from, DATE_FORMAT);
	}
	if (committedDateRange?.to) {
		params.endDate = format(committedDateRange.to, DATE_FORMAT);
	}

	return params;
}
